import React from "react";
import { Controller } from "react-hook-form";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";

interface InputTextFieldProps {
  fieldName: string;
  fieldType?: string;
  showPassword?: boolean;
  toggleShowPassword?: () => void | undefined;
  control: any;
  errors: any;
  placeholder: string;
  eyeStyle?: React.CSSProperties;
}

const InputTextField = ({
  fieldName,
  fieldType,
  showPassword,
  toggleShowPassword,
  control,
  errors,
  placeholder,
  eyeStyle,
}: InputTextFieldProps) => {
  return (
    <React.Fragment>
      <Controller
        control={control}
        name={fieldName}
        render={({ onChange, onBlur, value, name, ref }) => (
          <FormTextInput
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            inputRef={ref}
            type={fieldType == "password" ? (showPassword ? "text" : "password") : "text"}
            error={errors[fieldName]}
            placeholder={placeholder}
          />
        )}
      />
      {fieldType == "password" && toggleShowPassword && (
        <div onClick={() => toggleShowPassword()} className="eye-icon">
          <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"} style={eyeStyle} />
        </div>
      )}
    </React.Fragment>
  );
};

export default InputTextField;
